import {
  Box, Container, Heading, Text, Divider,
} from '@chakra-ui/react';
import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import React, { useEffect, useState } from 'react';
import { animated as a, useSpring } from 'react-spring';
import { graphql, useStaticQuery } from 'gatsby';
import { BsChevronDown } from 'react-icons/bs';
import { useMeasure } from 'react-use';
import FlareGroup4 from '../assets/shapes/shape-group-4.svg';

import { HalfByHalfSection, SEO } from '../components/_index';

const seoContent = {
  title: "Frequently Asked Questions - [We're #1 For A Reason]",
  description:
    'We Buy Houses in . We are a local home buying company in and we pay cash for houses. "Sell my house without cleaning or repairing or paying closing costs!"',
};

const faqQuestions = [
  {
    question: 'Who are you?',
    answer:
      "My name is Eugene Romberg and I am the owner of 'We Buy Houses In Bay Area'. My team is made up of the most educated and informed buyers in the Bay Area. Our 'About Us' page dives into further detail of who we are and what we do to help. We have integrity, honesty and your best interests at heart.",
  },
  {
    question: ' What do you do?',
    answer:
      'We buy and pay cash for houses in the Bay Area of California, in any condition or location. We are the best alternative if you do not want to deal with the stress of selling your home through traditional listings. If time is not an issue, but you want to avoid the expenses of listing your house through an agent, we are by far the best option.',
  },
  {
    question: "Is 'We Buy Houses In Bay Area' right for me?",
    answer:
      'As I have said before, we find it ethically appalling to make an offer based on how desperate you may or may not be able to sell. However, the majority of sellers I have purchased homes from in the Bay Area were not desperate to sell at all, nor were they looking to be rescued from foreclosure. The clients I have worked with chose us because of the bad experiences they had dealing with agents, the annoyance they had with walkthroughs and dealing with the repairs that needed to be done.',
  },
  {
    question: 'Will "We Buy Houses In Bay Area" List My House On The MLS?',
    answer:
      'Absolutely not. As I have said before, we are not agents. Our sole intention is to buy your Bay Area home for cash, and rehab it if any work needs to be done. Afterwards, we sell it again for a profit.',
  },
  {
    question: 'How are you different from a real estate agent?',
    answer:
      'Agents only market your Bay Area home, they do not actually buy it. Agent’s have fees that come alongside their services, such as commissions. If you list your Bay Area home with an agent, that means you pay closing costs, title fees, and you will have to endure a countless number of walkthroughs while your home is on the market.<br>My team and I are cash buyers and primarily real estate investors. We have our own private money and we are actually the ones buying your home. We can go immediately from the offer to closing on your property within 10 - 20 days. More importantly, we don’t charge any fees regarding commissions, we actually pay the closing costs.',
  },
  {
    question: 'How do I sell my Bay Area home Fash For Cash?',
    answer:
      'Fill out our form and describe your home a bit for us. With some information we can do a current market analysis on your Bay Area home and we use a formula (which we can break down and show to you) to present you with an all cash offer. Once you have accepted, there is nothing else to do but to receive your money at closing. Visit our How It Works page for more details.',
  },
  {
    question: 'Do I have any obligations after I fill out your form?',
    answer:
      'There are zero obligations when you fill out our form. In today’s economy, we know that you have options. We just want to be your first and best one. You have nothing to lose, while all to gain when working with us. We make you an offer, and if you accept, then great! You will get your cash quickly and easily. If you don’t accept, we will give you the information necessary to make the right choice.',
  },
  {
    question: 'Do I Need To Clean Before I Move Out?',
    answer:
      'You don’t have to clean anything before moving out. Just take what you need and leave us the rest, and I truly mean that. Clothes, rubble, furniture or even food in the fridge, it doesn’t matter to us. Believe me when I say that I have seen it all.',
  },
  {
    question: 'Do you pay fair prices for properties?',
    answer:
      'We pay very fair prices. However, there is a slight difference between a fair price and the market value of your Bay Area home. If the house is in bad shape, we use the market value of the house after it is renovated and subtract all the cost of repairs needed. The number we come up with is a fair price. We are the best in the Bay Area, and we present the highest offers.We know that if we give you the best offers, we will have more clients and beat out our competitors.',
  },
  {
    question: 'My house is in terrible condition, will you still buy it?',
    answer:
      'We buy homes in the Bay Area of California in any condition, good or bad. We are flippers, and with more room for improvement, the more attractive your house is to us. My team and I would absolutely love to buy your Bay Area home, even if it is in bad shape. Fill out our form and see how much we will offer, the results may even surprise you.',
  },
];

const Accordian = ({ data }) => {
  const q = data;
  const [show, setShow] = useState(false);
  const [contentHeight, setContentHeight] = useState('0px');
  const [ref, { height }] = useMeasure();
  const expand = useSpring({
    height: show ? `${contentHeight + 20}px ` : '0px',
  });
  useEffect(() => {
    // Sets initial height
    setContentHeight(height);

    // Adds resize event listener
    window.addEventListener('resize', setContentHeight(height));

    // Clean-up
    return window.removeEventListener('resize', setContentHeight(height));
  }, [height]);

  return (
    <Box
      px={5}
      pt={5}
      overflow="hidden"
      onClick={() => setShow(!show)}
    >
      <Box
        as="button"
        textAlign="left"
        display="flex"
        alignItems="center"
      >
        <Heading
          as="h4"
          size="xl"
          mr={4}
          pt={4}
        >
          {q.question}
        </Heading>
        <BsChevronDown style={{ fontSize: '2rem' }} />
      </Box>
      <a.div style={expand}>
        <Text
          pb={5}
          ref={ref}
          fontSize="xl"
          mt={10}
        >
          {q.answer}
        </Text>
      </a.div>
    </Box>
  );
};

const HeroContentBlock = () => (
  <>
    <Heading
      as="h1"
      size="3xl"
      lineHeight="base"
      mb={4}
    >
      <span className="highlight">Frequently Asked Questions</span>
    </Heading>
    <Heading
      variant="sec"
      size="xl"
    >
      We have put together some of most frequently ask questions to help you
      along the selling process.
      {' '}
    </Heading>
  </>
);

const FlareBlock = ({ img }) => (
  <Box
    zIndex="0"
    height={{ base: '15rem', md: '25rem' }}
  >
    <Box
      transform={{ base: 'scale(.8)', md: 'scale(1)' }}
      position="relative"
      width="20rem"
      mx="auto"
      height="15rem"
    >
      <Box
        position="relative"
        mt={4}
      >
        <Box
          position="absolute"
          top={{ base: '0%', md: '-20%' }}
          left="20%"
        >
          <FlareGroup4 className="width-400 height-500 width-md-600 height-md-600" />
        </Box>
        <Box
          position="absolute"
          top={{ base: '0%', md: '-20%' }}
          left="20%"
        >
          <GatsbyImage
            className="width-300"
            alt="happy home buyers image"
            image={img}
          />
        </Box>
      </Box>
    </Box>
  </Box>
);

const BaseHero = ({ data }) => {
  const flare = getImage(data.flareImage);
  return (
    <Box py={10}>
      <Container
        maxW="container.xl"
        position="relative"
        display="flex"
        flexWrap="wrap"
        mt={6}
      >
        <HalfByHalfSection
          left={<HeroContentBlock />}
          right={<FlareBlock img={flare} />}
        />
      </Container>
      <Container maxW="container.md">
        {faqQuestions.map((q, i) => (
          <Box mt={6}>
            <Accordian data={q} />
            <Divider />
          </Box>
        ))}
        <HalfByHalfSection
          left=" "
          right=""
        />
      </Container>
    </Box>
  );
};

const FAQPage = ({ data, location }) => (
  <main>
    <SEO
      location={location}
      title={seoContent.title}
      description={seoContent.description}
    />
    <BaseHero data={data} />
  </main>
);

export const query = graphql`
  query {
    heroImage: file(relativePath: { eq: "illustrations/meeting.png" }) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
    flareImage: file(relativePath: { eq: "people/happy-1.png" }) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
  }
`;

export default FAQPage;
